import { WHITOUT_INFORMATION } from '../utils/constants';

export function formatNumber(number) {
  if (number !== undefined && number !== null) {
    return number.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  else {
    return WHITOUT_INFORMATION;
  }
}

export function formatNumberMoney(number) {
  if (number !== undefined && number !== null) {
    return '$' + formatNumber(number);
  }
  else {
    return WHITOUT_INFORMATION;
  }
}

export function setFirstCapital(word) {
  return word.charAt(0)
    .toUpperCase() + word.slice(1);
}

export function formatStringMonth(month) {
  let aux='0';
  if(month.length===1){
    aux = aux.concat(month);
  }
  else{
    aux = month;
  }
  let mes;
  switch (aux) {
    case '01':
      mes = 'Enero';
      break;
    case '02':
      mes = 'Febrero';
      break;
    case '03':
      mes = 'Marzo';
      break;
    case '04':
      mes = 'Abril';
      break;
    case '05':
      mes = 'Mayo';
      break;
    case '06':
      mes = 'Junio';
      break;
    case '07':
      mes = 'Julio';
      break;
    case '08':
      mes = 'Agosto';
      break;
    case '09':
      mes = 'Septiembre';
      break;
    case '10':
      mes = 'Octubre';
      break;
    case '11':
      mes = 'Noviembre';
      break;
    case '12':
      mes = 'Diciembre';
      break;
    default:
      mes = '';
  }
  return mes;
}

/**
 * @return {number}
 */
export function Percentage(total, x){
  if(total!==undefined&&total!==null&&total!==0&&x!==undefined&&x!==null){
    console.log(total)
    console.log(x)
    return ((x*100/total).toFixed(2).toString()+'%');
  }
  else{
    return ('Sin información')
  }
}



// WEBPACK FOOTER //
// ./src/utils/formatters.js